import React, { useState } from 'react';
import { ErrorMessageBar } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormComponent } from 'src/domains/layouts/shared/cms/form/Form.style';
import { observer } from 'mobx-react-lite';
import { QuestionFormState } from './QuestionForm.state';
import { StatusInfo } from './components/StatusInfo';
import { useAppStateContext } from 'src/AppState/AppState';
import { CsvReadFile } from 'src/AppState/PromotionQuestionsState/PromotionQuestionsState';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { Switcher } from 'src/components/SwitcherNew/SwitcherOld';
import { Uploader } from 'src/components/Uploader/Uploader';
import { ContentH3, Label } from 'src/domains/layouts/shared/typography/Content.style';
import { FolderPlusIconWrapper } from 'src/components/Uploader/Uploader.style';
import { ButtonsWrapper } from 'src/domains/layouts/shared/buttons/Button.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const QuestionForm = observer(() => {
    const { promotionQuestionsState } = useAppStateContext();
    const { isSetActiveAllowed, isCreateMode } = promotionQuestionsState;
    const [state] = useState(() => new QuestionFormState(promotionQuestionsState));
    const question = promotionQuestionsState.currentQuestion;

    if (!isCreateMode && question === null) {
        return null;
    }
    const getFile = (): CsvReadFile | null => {
        if (state.questionFile !== null) {
            return state.questionFile;
        } else if (question === null) {
            return null;
        } else {
            return CsvReadFile.fromCsvReadItem(question);
        }
    };

    return (
        <>
            <ContentH3>{question === null ? 'Create new question' : 'Edit question'}</ContentH3>

            <FormComponent onSubmit={(e) => e.preventDefault()}>
                <Loader isActive={state.isLoading} />

                {Boolean(state.errorMessage) && <ErrorMessageBar>{state.errorMessage}</ErrorMessageBar>}

                <OldInput
                    label={`Question: (Max ${state.maxQuestionLength} characters)`}
                    status={state.questionStatus}
                    formInputState={state.question}
                    model={state.questionModel}
                />

                <Label>Upload CSV for answers</Label>
                <Uploader
                    state={state.file}
                    model={state.fileModel}
                    maxFileSize={state.maxFileSize}
                    allowedMimeTypes={state.allowedMimeTypes}
                    allowedFileTypes={state.allowedFileTypes}
                    file={getFile()}
                    onSelectFile={state.handleSelectFile}
                    onReplace={state.handleReplaceFile}
                    onRemove={state.handleRemoveFile}
                    uploadingFileName={state.questionFileName}
                />

                {!isSetActiveAllowed && (
                    <StatusInfo label='Status can’t be turned on as there is already three active questions. Turn one off in order to activate this one.' />
                )}
                <Switcher
                    state={state.status}
                    isDisabled={!isSetActiveAllowed}
                    label='Active for all customers'
                />

                <ButtonsWrapper>
                    <Button
                        version='secondary'
                        onClick={state.handleCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        isDisabled={!state.isFormValid}
                        onClick={state.handleSubmit}
                    >
                        <FolderPlusIconWrapper />
                        {question === null ? 'Publish' : 'Update'}
                    </Button>
                </ButtonsWrapper>
            </FormComponent>
        </>
    );
});
